"use client";

import { useCounterAnimation } from "@/components/marketing/hooks/useCounterAnimation";

const TESTIMONIALS_ROW1 = [
  { q: "J'ai vendu 3 trucs en une semaine. Avant c'\u00e9tait 3 par mois.", a: "Marie, Lyon" },
  { q: "Mes photos avaient l'air d'un shooting pro. Mon copain m'a demand\u00e9 si j'avais un photographe.", a: "L\u00e9a, Paris" },
  { q: "Le gain de temps est fou. Je faisais 20 min par annonce, l\u00e0 c'est 30 secondes.", a: "Camille, Bordeaux" },
  { q: "J'ai doubl\u00e9 mon prix moyen juste avec de meilleures photos.", a: "Sarah, Nantes" },
  { q: "Mon placard est vide, mon compte est plein. Merci Vitrine.", a: "Julie, Marseille" },
  { q: "Je recommande \u00e0 toutes mes copines. On fait des soir\u00e9es Vitrine maintenant.", a: "Manon, Toulouse" },
];

const TESTIMONIALS_ROW2 = [
  { q: "Vitrine comprend vraiment les v\u00eatements. Les descriptions sont parfaites.", a: "Clara, Strasbourg" },
  { q: "J'utilisais Vinted depuis 2 ans sans rien vendre. Premi\u00e8re semaine avec Vitrine : 5 ventes.", a: "Emma, Lille" },
  { q: "Les hashtags g\u00e9n\u00e9r\u00e9s sont exactement ce que les gens cherchent.", a: "In\u00e8s, Montpellier" },
  { q: "Je ne savais jamais quel prix mettre. Maintenant c'est r\u00e9gl\u00e9.", a: "Chlo\u00e9, Nice" },
  { q: "Mes annonces ressemblent \u00e0 celles des pros. Sauf que \u00e7a m'a pris 30 secondes.", a: "Zo\u00e9, Rennes" },
  { q: "M\u00eame ma m\u00e8re l'utilise. C'est dire si c'est simple.", a: "Lucie, Grenoble" },
];

function TestimonialCard({ quote, author }: { quote: string; author: string }) {
  return (
    <div
      style={{
        flexShrink: 0,
        width: 340,
        background: "rgba(253,246,238,0.06)",
        border: "1px solid rgba(253,246,238,0.08)",
        borderRadius: 16,
        padding: 24,
      }}
    >
      <q
        style={{
          fontFamily: "var(--font-headline), Georgia, serif",
          fontStyle: "italic",
          fontSize: 15,
          lineHeight: 1.6,
          color: "rgba(253,246,238,0.85)",
          display: "block",
          marginBottom: 16,
          quotes: '"\u201C" "\u201D"',
        }}
      >
        {quote}
      </q>
      <div
        style={{
          fontSize: 13,
          color: "rgba(253,246,238,0.4)",
          fontWeight: 500,
        }}
      >
        {author}
      </div>
    </div>
  );
}

function TickerRow({
  testimonials,
  direction,
}: {
  testimonials: typeof TESTIMONIALS_ROW1;
  direction: "left" | "right";
}) {
  const items = [...testimonials, ...testimonials];

  return (
    <div
      style={{
        display: "flex",
        gap: 20,
        marginBottom: 20,
        width: "max-content",
        animation:
          direction === "left"
            ? "tickerLeft 40s linear infinite"
            : "tickerRight 45s linear infinite",
        willChange: "transform",
      }}
    >
      {items.map((t, i) => (
        <TestimonialCard key={`${t.a}-${i}`} quote={t.q} author={t.a} />
      ))}
    </div>
  );
}

export default function TestimonialsSection() {
  const { ref: counterRef, display } = useCounterAnimation(1247, 2000);

  return (
    <section
      style={{
        background: "var(--color-mkt-chocolate, #2C2520)",
        padding: "80px 0",
        overflow: "hidden",
        position: "relative",
        borderRadius: '32px 32px 0 0',
        marginTop: -32,
        zIndex: 2,
      }}
    >
      <TickerRow testimonials={TESTIMONIALS_ROW1} direction="left" />
      <TickerRow testimonials={TESTIMONIALS_ROW2} direction="right" />

      {/* Center counter */}
      <div style={{ textAlign: "center", padding: "40px 0 20px" }}>
        <div
          style={{
            fontFamily: "var(--font-headline), Georgia, serif",
            fontStyle: "italic",
            fontSize: "clamp(32px, 5vw, 48px)",
            color: "var(--color-mkt-cream, #FDF6EE)",
          }}
        >
          <span ref={counterRef}>{display}</span> annonces cr{"\u00e9\u00e9"}es
        </div>
        <div
          style={{
            fontSize: 16,
            color: "rgba(253,246,238,0.5)",
            marginTop: 4,
          }}
        >
          et {"\u00E7"}a continue
        </div>
      </div>

      <style>{`
        @keyframes tickerLeft {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        @keyframes tickerRight {
          0% { transform: translateX(-50%); }
          100% { transform: translateX(0); }
        }
      `}</style>
    </section>
  );
}
